import React, { useContext } from "react";
import { Context } from "../../context/Context";

export default function ImageShare() {
  const { codeExport, state } = useContext(Context);
  return (
    <div className="mt-5 w-full">
      <span className="text-sm text-gray-600 font-medium  inline-block">
        IMAGE
      </span>
      <br />
      <div className="flex items-center mt-2 h-16">
        <img
          src={codeExport.imageUrl}
          alt=""
          className="w-16 h-16 border p-1 rounded-sm object-contain"
        />
        <div className="pl-5 h-full  ">
          <p className="m-0 text-gray-600 text-base font-semibold">
            {state.fileName.split(".")[0]===''?'untitled':state.fileName.split(".")[0]}.png
          </p>
          <p className="m-0 mt-1 text-gray-500 text-sm">
            {codeExport.width} X {codeExport.height}
          </p>
        </div>
      </div>
    </div>
  );
}
